export const schema = `
PRAGMA foreign_keys = ON;

CREATE TABLE IF NOT EXISTS palomos (
  id TEXT PRIMARY KEY,
  anilla TEXT,
  nombre TEXT NOT NULL DEFAULT '',
  plumaje TEXT NOT NULL DEFAULT '',
  sexo TEXT NOT NULL DEFAULT '',
  observaciones TEXT NOT NULL DEFAULT '',
  created_at TEXT NOT NULL,
  updated_at TEXT NOT NULL,
  deleted_at TEXT,
  sync_status TEXT NOT NULL DEFAULT 'local',
  version INTEGER NOT NULL DEFAULT 1
);
DROP INDEX IF EXISTS ux_palomos_anilla;
CREATE INDEX IF NOT EXISTS ix_palomos_anilla ON palomos(anilla) WHERE anilla IS NOT NULL AND anilla <> '';

CREATE TABLE IF NOT EXISTS hojas_cria (
  id TEXT PRIMARY KEY,
  anio INTEGER NOT NULL,
  numero INTEGER NOT NULL,
  estado TEXT NOT NULL DEFAULT 'guardada',
  created_at TEXT NOT NULL,
  updated_at TEXT NOT NULL,
  deleted_at TEXT,
  sync_status TEXT NOT NULL DEFAULT 'local',
  version INTEGER NOT NULL DEFAULT 1,
  UNIQUE(anio, numero)
);

CREATE TABLE IF NOT EXISTS parejas (
  id TEXT PRIMARY KEY,
  hoja_id TEXT NOT NULL UNIQUE REFERENCES hojas_cria(id),
  padre_id TEXT NOT NULL REFERENCES palomos(id),
  madre_id TEXT NOT NULL REFERENCES palomos(id),
  created_at TEXT NOT NULL,
  updated_at TEXT NOT NULL,
  deleted_at TEXT,
  sync_status TEXT NOT NULL DEFAULT 'local',
  version INTEGER NOT NULL DEFAULT 1
);

CREATE TABLE IF NOT EXISTS pichones_hoja (
  id TEXT PRIMARY KEY,
  hoja_id TEXT NOT NULL REFERENCES hojas_cria(id),
  palomo_id TEXT NOT NULL REFERENCES palomos(id),
  orden INTEGER NOT NULL,
  observaciones TEXT NOT NULL DEFAULT '',
  fila_tachada INTEGER NOT NULL DEFAULT 0,
  created_at TEXT NOT NULL,
  updated_at TEXT NOT NULL,
  deleted_at TEXT,
  sync_status TEXT NOT NULL DEFAULT 'local',
  version INTEGER NOT NULL DEFAULT 1
);

CREATE TABLE IF NOT EXISTS imagenes_documentos (
  id TEXT PRIMARY KEY,
  hoja_id TEXT NOT NULL REFERENCES hojas_cria(id),
  ruta TEXT NOT NULL,
  nombre_original TEXT NOT NULL,
  mime_type TEXT NOT NULL,
  tamano_bytes INTEGER NOT NULL,
  created_at TEXT NOT NULL,
  deleted_at TEXT,
  sync_status TEXT NOT NULL DEFAULT 'local',
  version INTEGER NOT NULL DEFAULT 1
);

CREATE TABLE IF NOT EXISTS prefijos_anilla (
  anio INTEGER PRIMARY KEY,
  prefijo TEXT NOT NULL,
  updated_at TEXT NOT NULL,
  sync_status TEXT NOT NULL DEFAULT 'local',
  version INTEGER NOT NULL DEFAULT 1
);

CREATE TABLE IF NOT EXISTS excel_imports (
  id TEXT PRIMARY KEY,
  filename TEXT NOT NULL,
  imported_at TEXT NOT NULL
);

CREATE TABLE IF NOT EXISTS excel_palomos (
  id TEXT PRIMARY KEY,
  import_id TEXT NOT NULL REFERENCES excel_imports(id),
  anilla TEXT,
  nombre TEXT NOT NULL DEFAULT '',
  plumaje TEXT NOT NULL DEFAULT '',
  sexo TEXT NOT NULL DEFAULT '',
  observaciones TEXT NOT NULL DEFAULT ''
);
CREATE INDEX IF NOT EXISTS ix_excel_palomos_anilla ON excel_palomos(anilla);
CREATE INDEX IF NOT EXISTS ix_excel_palomos_nombre ON excel_palomos(nombre);

CREATE TABLE IF NOT EXISTS excel_apariciones (
  id TEXT PRIMARY KEY,
  palomo_id TEXT NOT NULL REFERENCES excel_palomos(id),
  anio INTEGER NOT NULL,
  hoja INTEGER NOT NULL,
  rol TEXT NOT NULL,
  observaciones TEXT NOT NULL DEFAULT '',
  padre_nombre TEXT NOT NULL DEFAULT '',
  padre_anilla TEXT NOT NULL DEFAULT '',
  padre_plumaje TEXT NOT NULL DEFAULT '',
  madre_nombre TEXT NOT NULL DEFAULT '',
  madre_anilla TEXT NOT NULL DEFAULT '',
  madre_plumaje TEXT NOT NULL DEFAULT ''
);
CREATE INDEX IF NOT EXISTS ix_excel_apariciones_palomo ON excel_apariciones(palomo_id);

CREATE TABLE IF NOT EXISTS bird_status_overrides (
  identity_key TEXT PRIMARY KEY,
  status TEXT NOT NULL CHECK(status IN ('dead', 'gifted', 'home', 'lost')),
  updated_at TEXT NOT NULL,
  sync_status TEXT NOT NULL DEFAULT 'local',
  version INTEGER NOT NULL DEFAULT 1
);
`
